import React from 'react';
import { 
  Footprints,
  Clapperboard,
  DoorOpen,
  Square,
  ChevronLeft, 
  ChevronRight, 
  ChevronUp, 
  ChevronDown,
  ArrowLeft,
  ArrowRight,
  List,
  Maximize2,
  Info,
  Navigation,
  Eye
} from 'lucide-react';
import { Button } from './ui/button';
import { mockPaintings } from '../data/mockGalleryData';
import ClimateControl from './ClimateControl';
import TimeControl from './TimeControl';
import LikeButton from './LikeButton';
import { paintingSlug } from '../data/mockGalleryData';

const NavigationControls = ({ 
  currentPaintingIndex, 
  onPaintingChange, 
  onShowList, 
  onShowInfo,
  onFullscreen,
  // onCameraMove,// OLD: Prop commented out
  // FIX 1: Destructure the new start/stop handlers from props.
  onStartCameraMove,
  onStopCameraMove,
  isMobile = false,
  isGuideMode,
  onToggleGuideMode,
  isTourActive,
  onToggleTour,
  timeOfDay,
  localTimeOfDay,
  onTimeOfDayChange,
  climateMode,
  localWeather,
  climate,
  onClimateChange,
  autoClimateSeconds,
  weatherSoundOn,
  onToggleWeatherSound,
  likes,
  onToggleLike,
  musicSlotRef,
  onEnterTheatre,
  inSalon = false,
  onSwitchRoom
}) => {
  const nextPainting = () => {
    const nextIndex = (currentPaintingIndex + 1) % mockPaintings.length;
    onPaintingChange(nextIndex);
  };

  const prevPainting = () => {
    const prevIndex = currentPaintingIndex === 0 ? mockPaintings.length - 1 : currentPaintingIndex - 1;
    onPaintingChange(prevIndex);
  };

  const currentPainting = mockPaintings[currentPaintingIndex];

  const buttonSize = isMobile ? 'sm' : 'icon';
  const containerClasses = `gallery-ui ${isMobile ? 'gallery-controls' : ''}`;

  return (
    <>
      {/* Movement Controls - Bottom Left */}
      {!isMobile && (
      <div className={`fixed bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg shadow-lg p-3 border ${containerClasses}`}>
        <div className="grid grid-cols-3 gap-1">
          <div></div>
          <Button
            variant="ghost"
            size={buttonSize}
            /*
            // OLD: onClick only fires once.
            onClick={() => {
              console.log('Forward button clicked');
              onCameraMove('forward')
            }}
            */
            // FIX 1: Add event handlers for press-and-hold functionality on desktop and mobile.
            onMouseDown={() => onStartCameraMove('forward')}
            onMouseUp={() => onStopCameraMove('forward')}
            onMouseLeave={() => onStopCameraMove('forward')} // Stops movement if the cursor leaves while pressed
            onTouchStart={() => onStartCameraMove('forward')}
            onTouchEnd={() => onStopCameraMove('forward')}
            className={`${isMobile ? 'h-10 w-10' : 'h-5 w-5'} text-amber-800 hover:bg-amber-100 gallery-button`}
            title="Move Forward"
          >
            <ChevronUp size={isMobile ? 20 : 16} />
          </Button>
          <div></div>
          
          <Button
            variant="ghost"
            size={buttonSize}
            // onClick={() => onCameraMove('left')} // OLD
            // FIX 1: Add event handlers
            onMouseDown={() => onStartCameraMove('left')}
            onMouseUp={() => onStopCameraMove('left')}
            onMouseLeave={() => onStopCameraMove('left')}
            onTouchStart={() => onStartCameraMove('left')}
            onTouchEnd={() => onStopCameraMove('left')}
            className={`${isMobile ? 'h-10 w-10' : 'h-5 w-5'} text-amber-800 hover:bg-amber-100 gallery-button`}
            title="Move Left"
          >
            <ChevronLeft size={isMobile ? 20 : 16} />
          </Button>
          <Button
            variant="ghost"
            size={buttonSize}
            // onClick={() => onCameraMove('backward')} // OLD
            // FIX 1: Add event handlers
            onMouseDown={() => onStartCameraMove('backward')}
            onMouseUp={() => onStopCameraMove('backward')}
            onMouseLeave={() => onStopCameraMove('backward')}
            onTouchStart={() => onStartCameraMove('backward')}
            onTouchEnd={() => onStopCameraMove('backward')}
            className={`${isMobile ? 'h-10 w-10' : 'h-5 w-5'} text-amber-800 hover:bg-amber-100 gallery-button`}
            title="Move Backward"
          >
            <ChevronDown size={isMobile ? 20 : 16} />
          </Button>
          <Button
            variant="ghost"
            size={buttonSize}
            // onClick={() => onCameraMove('right')} // OLD
            // FIX 1: Add event handlers
            onMouseDown={() => onStartCameraMove('right')}
            onMouseUp={() => onStopCameraMove('right')}
            onMouseLeave={() => onStopCameraMove('right')}
            onTouchStart={() => onStartCameraMove('right')}
            onTouchEnd={() => onStopCameraMove('right')}
            className={`${isMobile ? 'h-10 w-10' : 'h-5 w-5'} text-amber-800 hover:bg-amber-100 gallery-button`}
            title="Move Right"
          >
            <ChevronRight size={isMobile ? 20 : 14} />
          </Button>
        </div>
      </div>
      )}

      {/* Painting Navigation - bottom centre (between the joysticks on phones) */}
      <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-sm rounded-lg shadow-lg p-2 border ${isMobile ? 'max-w-[calc(100vw-232px)]' : ''}`}>
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size={buttonSize}
            onClick={prevPainting}
            className={`${isMobile ? 'h-8 w-8' : 'h-7 w-7'} text-amber-800 hover:bg-amber-100`}
            title="Previous Artwork"
          >
            <ArrowLeft size={isMobile ? 10 : 14} />
          </Button>
          
          <div className={`flex flex-col items-center ${isMobile ? 'min-w-[70px]' : 'min-w-[120px]'}`}>
            <div className={`${isMobile ? 'text-xs' : 'text-xs'} font-medium text-gray-800 truncate max-w-full`}>
              {currentPainting.title}
            </div>
            {/* hide index on mobile */}
            {!isMobile && (
              <div className="text-xs text-gray-500 flex items-center gap-1">
                {currentPaintingIndex + 1} of {mockPaintings.length}
                {likes && <LikeButton paintingId={paintingSlug(currentPainting)} likes={likes} onToggle={onToggleLike} />}
              </div>
            )}
            {isMobile && likes && <LikeButton paintingId={paintingSlug(currentPainting)} likes={likes} onToggle={onToggleLike} />}
          </div>
          
          <Button
            variant="ghost"
            size={buttonSize}
            onClick={nextPainting}
            className={`${isMobile ? 'h-8 w-8' : 'h-7 w-7'} text-amber-800 hover:bg-amber-100`}
            title="Next Artwork"
          >
            <ArrowRight size={isMobile ? 10 : 14} />
          </Button>
        </div>
      </div>



      {/* Top Controls */}
      <div className="fixed top-4 right-4 flex flex-col space-y-2">
        {/* View All Artworks */}
        <Button
          variant="ghost"
          size={isMobile ? "sm" : "sm"}
          onClick={onShowList}
          className="h-10 w-10 rounded-full bg-white/90 shadow-md text-amber-800 hover:bg-amber-100"
          title="View All Artworks"
        >
          <List size={16} />
        </Button>

        {/* Guided Tour */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleTour}
          className={`h-10 w-10 rounded-full shadow-md ${isTourActive ? 'bg-amber-600 text-white hover:bg-amber-700' : 'bg-white/90 text-amber-800 hover:bg-amber-100'}`}
          title={isTourActive ? 'Stop guided tour (T)' : 'Start guided tour (T)'}
        >
          {isTourActive ? <Square size={14} /> : <Footprints size={16} />}
        </Button>

        {/* Walk through the glass door to the other room */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onSwitchRoom}
          className="h-10 w-10 rounded-full bg-white/90 shadow-md text-amber-800 hover:bg-amber-100"
          title={inSalon ? 'Back to the Glass Hall' : 'Enter the Grand Salon'}
        >
          <DoorOpen size={16} />
        </Button>

        {/* Theatre mode (glass hall only) */}
        {!inSalon && <Button
          variant="ghost"
          size="sm"
          onClick={onEnterTheatre}
          className="h-10 w-10 rounded-full bg-white/90 shadow-md text-amber-800 hover:bg-amber-100"
          title="Theatre: watch how the paintings were made"
        >
          <Clapperboard size={16} />
        </Button>}

        {/* Time of day */}
        <TimeControl value={timeOfDay} startedFrom={localTimeOfDay} onChange={onTimeOfDayChange} />

        {/* Climate */}
        {!inSalon && <ClimateControl mode={climateMode} climate={climate} localWeather={localWeather} onChange={onClimateChange} autoSeconds={autoClimateSeconds} soundOn={weatherSoundOn} onToggleSound={onToggleWeatherSound} />}

        {/* Artwork Info */}
        <Button
          variant="ghost"
          size={isMobile ? "sm" : "sm"}
          onClick={onShowInfo}
          className="h-10 w-10 rounded-full bg-white/90 shadow-md text-amber-800 hover:bg-amber-100"
          title="Artwork Information"
        >
          <Info size={16} />
        </Button>

        {/* Fullscreen (Desktop only) */}
        {!isMobile && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onFullscreen}
            className="h-10 w-10 rounded-full bg-white/90 shadow-md text-amber-800 hover:bg-amber-100"
            title="Fullscreen"
          >
            <Maximize2 size={16} />
          </Button>
        )}

        {/* Music play / pause (the AudioPlayer, which lives in App.js, shows its button here) */}
        <div ref={musicSlotRef} />
      </div>


      {/* Progress Indicator - Disabled since guide mode is disabled */}
      {/* {isGuideMode && (
        <div className={`fixed top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg shadow-lg p-3 border ${containerClasses}`}>
          <div className="flex items-center space-x-2">
            <div className={`${isMobile ? 'text-xs' : 'text-sm'} font-medium text-gray-800 gallery-info`}>
              {isMobile ? 'Progress' : 'Gallery Progress'}
            </div>
            <div className={`${isMobile ? 'w-20' : 'w-32'} bg-gray-200 rounded-full h-2`}>
              <div 
                className="bg-amber-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${((currentPaintingIndex + 1) / mockPaintings.length) * 100}%` }}
              ></div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default NavigationControls;